// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEmailCheckDeliverableBody = {
  email: string;
};

export type typeEmailCheckDeliverableOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    isDeliverable: boolean;
    reason?: "invalidFormat" | "noMxRecord" | null;
  };
};

export type typeEmailCheckDeliverableOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEmailCheckDeliverableOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEmailCheckDeliverableOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEmailCheckDeliverableBody = {
  type: "object",
  properties: { email: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["email"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEmailCheckDeliverable(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEmailCheckDeliverableBody);
  }

  return async function postEmailCheckDeliverable(
    payload: typeEmailCheckDeliverableBody,
  ): Promise<
    typeEmailCheckDeliverableOutput200 | typeEmailCheckDeliverableOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEmailCheckDeliverable" failed before calling the network. #4d4ce976dc65`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#4d4ce976dc65" },
        },
        data: null,
      } as typeEmailCheckDeliverableOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/email/check-deliverable`,
      httpMethod: "POST",
      options,
    })) as
      typeEmailCheckDeliverableOutput200 | typeEmailCheckDeliverableOutput400;
  };
}
